import * as requests from '../api-request'
import getToken from '../get-token'

export const generateCover = async (data, token) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'competitions/generate_cover', data, token)
}

export const generateTitleAndDescription = async (data, token) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'competitions/generate_title_and_description', data, token)
}

export const createCompetition = async (data, token) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'competitions', data, token)
}

export const sendInvitations = async (data, token) => {
  token = token || (await getToken())
  return requests.toJSON('POST', 'competitions/invitation', data, token)
}

export const updateCompetition = async (uuid, data) => {
  return requests.toJSON('PATCH', `competitions/${uuid}`, data)
}

export const getCompetition = async (competitionId) => {
  return requests.toJSON('GET', `competitions/${competitionId}`)
}

export const deleteCompetition = async (competitionId) => {
  return requests.toJSON('DELETE', `competitions/${competitionId}`)
}

export const getParticipantsCount = async (competitionId) => {
  return requests.toJSON('GET', `competitions/participants_count/${competitionId}`)
}

export const getCompetitionByEmailAndId = async (data) => {
  const queryString = new URLSearchParams(data)
  return requests.toJSON('GET', `competitions?${queryString}`)
}

export const acceptCompetition = async (data) => {
  return requests.toJSON('POST', 'competitions/accept', data)
}

export const competitionsList = async () => {
  return requests.toJSON('GET', 'competitions/list')
}

export const getSubmissions = async (competitionId) => {
  return requests.toJSON('GET', `competitions/submissions/${competitionId}`)
}

export const judge = async (data) => {
  return requests.toJSON('POST', 'competitions/judge', data)
}

export const getTermsOfUse = async (data) => {
  const queryString = new URLSearchParams(data)
  return requests.toBlob('GET', `competitions/terms-of-use?${queryString}`)
}

export const getJuries = async () => {
  return requests.toJSON('GET', 'competitions/juries-list')
}
